import { render, staticRenderFns } from "./rockId.vue?vue&type=template&id=ed3d6772&scoped=true&lang=pug&"
import script from "./rockId.vue?vue&type=script&lang=js&"
export * from "./rockId.vue?vue&type=script&lang=js&"
import style0 from "./rockId.vue?vue&type=style&index=0&id=ed3d6772&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3d6772",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed3d6772')) {
      api.createRecord('ed3d6772', component.options)
    } else {
      api.reload('ed3d6772', component.options)
    }
    module.hot.accept("./rockId.vue?vue&type=template&id=ed3d6772&scoped=true&lang=pug&", function () {
      api.rerender('ed3d6772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rockyInfo/rockyId/rockId.vue"
export default component.exports